/* MIS MarineBond "Installed on real boats": tap/click a photo to see it larger in a native <dialog>.
   Esc, the close button or a click on the backdrop closes it, and focus returns to the photo. */
if (!customElements.get('mb-gallery')) {
  class MbGallery extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-mb-zoom]');
        if (!link) return;
        event.preventDefault();
        this.opener = link;
        if (!this.img) {
          this.img = document.createElement('img');
          this.img.className = 'mb-zoom__img';
          this.dialog.appendChild(this.img);
        }
        this.img.src = link.href;
        this.img.alt = link.dataset.alt || '';
        this.dialog.showModal();
        this.dialog.querySelector('.mb-zoom__close').focus();
      });
      this.dialog.querySelector('.mb-zoom__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (this.opener) this.opener.focus();
      });
    }
  }
  customElements.define('mb-gallery', MbGallery);
}
